<template>
  <b-modal
    hideFooter=""
    noCloseOnBackdrop=""
    id="auth-code-modal"
    ref="modalElement"
    dialogClass="mw-650px index-modal"
    header-class="pb-0 border-0 justify-content-end mb-5"
    bodyClass="text-center scroll-y mx-5 mx-xl-18 pt-0 pb-15"
    v-model="authModalVisible"
    :onShow="onShow"
    :onHide="onHide"
    :onCancel="onHide"
  >
    <template v-slot:header>
      <div
        class="btn btn-sm btn-icon btn-active-color-primary"
        data-bs-dismiss="modal"
      >
        <span class="svg-icon svg-icon-1">
          <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </template>
    <div class="mb-13">
      <h1 class="mb-3">Verify your action</h1>
      <div class="text-gray-400 fw-bold fs-5">
        Enter code from your Two-Factor Auth application
      </div>
    </div>
    <VeeForm
      id="kt_modal_create_bank_account_form"
      class="form"
      ref="formElement"
      :validation-schema="validationSchema"
    >
      <div class="mb-5 fv-row">
        <!--begin::Label-->
        <label class="required fs-5 fw-bold mb-2">Auth Code</label>
        <!--end::Label-->
        <!--begin::Input-->
        <Field
          type="text"
          class="form-control form-control-solid"
          placeholder="Auth Code..."
          name="auth_code"
          id="auth_code"
          maxlength="6"
          v-model="tfaCode"
          :validateOnBlur="false"
          :model-value="$store.getters.tfa_code"
          :disabled="$store.getters.is_tfa_submitting"
        />
        <div class="fv-plugins-message-container">
          <div class="fv-help-block">
            <span
              v-if="$store.getters.is_tfa_submitting && 'on'"
              class="text-success"
              >Code accepted. Verification process...</span
            >
            <ErrorMessage v-else name="auth_code" />
          </div>
        </div>
        <!--end::Input-->
      </div>
      <!--begin::Button-->
      <button
        type="button"
        class="btn btn-danger"
        @click="authModalVisible = false"
      >
        Cancel
      </button>
      <!--end::Button-->
    </VeeForm>
  </b-modal>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { Form as VeeForm, ErrorMessage, Field } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "auth-code-modal",
  components: {
    VeeForm,
    ErrorMessage,
    Field,
  },
  setup() {
    const store = useStore();
    const modalElement = ref<null | HTMLElement>(null);
    const formElement = ref<null | HTMLFormElement>(null);
    const submitButton = ref<null | HTMLButtonElement>(null);
    const authModalVisible = ref<boolean>(false);
    const tfaCode = ref<null | string>("");

    const validationSchema = Yup.object().shape({
      auth_code: Yup.string().length(6).nullable().label("Auth Code"),
    });

    const toggleModal = (state: boolean) => {
      const test = formElement?.value;
      test?.resetForm();
      if (state) {
        authModalVisible.value = true;
        setTimeout(() => {
          document.getElementById("auth_code")?.focus({ preventScroll: false });
        }, 1000);

        return true;
      }

      return (authModalVisible.value = false);
    };

    const onShow = () => {
      formElement?.value?.setFieldError("auth_code", "");
      store.commit(Mutations.COMMON_AUTH_TFA_CODE_CHANGE_CANCELED, false);
    };

    const onHide = () => {
      store.commit(Mutations.COMMON_AUTH_TFA_CODE_CHANGE_STATE, false);
      store.commit(Mutations.COMMON_AUTH_TFA_CODE_CHANGE_CANCELED, true);
    };

    const resetSubmitting = () => {
      if (!store.getters.is_tfa_submitting) {
        store.commit(Mutations.COMMON_AUTH_TFA_CODE_SET_SUBMITTING, false);
        if (tfaCode.value?.length === 6) {
          store.commit(Mutations.COMMON_AUTH_TFA_CODE_SET, tfaCode.value);
          store.commit(Mutations.COMMON_AUTH_TFA_CODE_SET_SUBMITTING, true);
          tfaCode.value = "";
        }
      }
    };

    watch(() => tfaCode.value, resetSubmitting);
    watch(() => store.getters.is_tfa_required, toggleModal);
    watch(
      () => store.getters.get_tfa_error,
      (error) => {
        if (!formElement.value) {
          return;
        }
        formElement.value.setFieldError("auth_code", error);
      }
    );

    return {
      modalElement,
      formElement,
      tfaCode,
      validationSchema,
      submitButton,
      authModalVisible,
      onShow,
      onHide,
      resetSubmitting,
    };
  },
});
</script>
<style>
.index-modal {
  z-index: 1055;
}
</style>
